import { ReactNode } from "react"
import { component, definition, styles } from "@uesio/ui"

interface TitleBarUtilityProps {
  title?: string
  subtitle?: string
  subtitlenode?: ReactNode
  actions?: ReactNode
  avatar?: ReactNode
  onClick?: () => void
}

const StyleDefaults = Object.freeze({
  root: [],
  content: [],
  title: [],
  subtitle: [],
  actions: [],
  avatar: ["empty:hidden"],
})

const TitleBar: definition.UtilityComponent<TitleBarUtilityProps> = (props) => {
  const {
    context,
    title,
    subtitle,
    subtitlenode,
    actions,
    onClick,
    id,
    avatar,
  } = props
  const classes = styles.useUtilityStyleTokens(
    StyleDefaults,
    props,
    "uesio/io.titlebar",
  )
  const mergedTitle = context.mergeString(title)
  const mergedSubtitle =
    subtitle || subtitle === "" ? context.mergeString(subtitle) : undefined
  const subtitleElement = (subtitle || subtitle === "") && (
    <p className={classes.subtitle}>
      {subtitle === "" ? <>&nbsp;</> : mergedSubtitle}
    </p>
  )

  return (
    <div
      id={id}
      role={onClick ? "button" : undefined}
      onClick={() => onClick && onClick()}
      className={classes.root}
    >
      {avatar ? <div className={classes.avatar}>{avatar}</div> : undefined}
      <div className={classes.content}>
        <p className={classes.title}>{mergedTitle}</p>

        {/* Render whitespace if subtitle is empty string. Non-empty
            subtitles use the shared tooltip instead of the browser
            `title` attribute because native tooltips can clip long
            generated descriptions with no way to scroll. Keep the
            shared tooltip's normal chrome; only cap size and wrap. */}
        {mergedSubtitle ? (
          <component.Utility
            utilityKey="uesio/io.tooltip"
            text={mergedSubtitle}
            context={context}
            maxWidth="min(480px, calc(100vw - 32px))"
            contentStyle={{
              maxHeight: "min(70vh, 720px)",
              overflowY: "auto",
              whiteSpace: "pre-wrap",
              overflowWrap: "anywhere",
            }}
          >
            {subtitleElement}
          </component.Utility>
        ) : (
          subtitleElement
        )}
        {subtitlenode}
      </div>
      <div className={classes.actions}>{actions}</div>
    </div>
  )
}

export default TitleBar
